import { render, staticRenderFns } from "./YaJinBuJiaoDetail.vue?vue&type=template&id=52ffde3a&scoped=true&"
import script from "./YaJinBuJiaoDetail.vue?vue&type=script&lang=js&"
export * from "./YaJinBuJiaoDetail.vue?vue&type=script&lang=js&"
import style0 from "./YaJinBuJiaoDetail.vue?vue&type=style&index=0&id=52ffde3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ffde3a",
  null
  
)

export default component.exports